import { AfterViewInit, Directive, ElementRef, inject, input, OnDestroy } from '@angular/core';

/** Permite que el navegador guarde credenciales en la pantalla de login. */
@Directive({
  selector: 'lib-input[loginAutocomplete]',
  standalone: true,
})
export class LoginInputAutocompleteDirective implements AfterViewInit, OnDestroy {
  readonly loginAutocomplete = input.required<string>();
  readonly loginInputName = input('');

  private readonly host = inject(ElementRef<HTMLElement>);
  private readonly timeouts: number[] = [];

  ngAfterViewInit(): void {
    this.applyToInput();
    for (const delay of [0, 50, 200, 500]) {
      this.timeouts.push(window.setTimeout(() => this.applyToInput(), delay));
    }
  }

  ngOnDestroy(): void {
    this.timeouts.forEach((id) => window.clearTimeout(id));
  }

  private applyToInput(): void {
    const input = this.host.nativeElement.querySelector('input');
    if (!input) return;

    const autocomplete = this.loginAutocomplete();
    input.setAttribute('autocomplete', autocomplete);

    const name = this.loginInputName();
    if (name) {
      input.setAttribute('name', name);
      input.id = name;
    }

    if (autocomplete === 'username') {
      input.setAttribute('autocapitalize', 'off');
      input.setAttribute('autocorrect', 'off');
      input.setAttribute('spellcheck', 'false');
      input.removeAttribute('inputmode');
    }
  }
}
